import { agentTypes } from "@agent/agent-types.di";
import type { PathogenTypeEnum } from "@agent/domain/models/agent.model";
import type { AgentRepository } from "@agent/domain/repositories/agent.repository";
import type { CheckboxOption } from "@core/domain/types/checkbox-option";
import { inject, injectable } from "inversify";

@injectable()
export class PathogenTypeGetAllUseCase {
    constructor(
        @inject(agentTypes.repositories.AgentRepository)
        private readonly agentRepository: AgentRepository,
    ) {}

    execute(): CheckboxOption<PathogenTypeEnum>[] {
        const pathogenTypes = this.agentRepository.pathogenTypeGetAll();

        return pathogenTypes.map((option) => ({
            label: option.label,
            value: option.value,
        }));
    }
}
